export default __webpack_public_path__ + "static/media/dot-background.c18d167e.jpeg";